module.exports = __webpack_public_path__ + "static/media/title_node.0c1b07a2.PNG";